import { render } from "./Edit-desktop-or-mobile-css-style.vue?vue&type=template&id=62d304f0&scoped=true"
import script from "./Edit-desktop-or-mobile-css-style.vue?vue&type=script&lang=js"
export * from "./Edit-desktop-or-mobile-css-style.vue?vue&type=script&lang=js"

import "./styles.scss?vue&type=style&index=0&id=62d304f0&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d304f0"]])

export default __exports__